import {Image} from '@yandex-delivery/blocks'
import {flow, get} from '@yandex-delivery/utils'
import type {FC, ReactElement} from 'react'

import {tagToUrl} from '../../lib/tagToUrl'
import type {IconWidgetProps as Props} from '../types'

export const IconWidget: FC<Props> = //
  flow(
    get('config.icon.image_tag'), //
    tagToUrl,
    (src: string): ReactElement => <Image alt="" height={32} src={src} />,
  )
IconWidget.displayName = 'IconWidgetDesktop'
